module.exports = __webpack_public_path__ + "media/images/riders/THOMAS_ESTAQUE-9c6d41618b6669d1d48f276fcfac55c7.png";